
  document.addEventListener('DOMContentLoaded', function () {
    const parentItems = document.querySelectorAll('.menu-parent-item');

    parentItems.forEach((parentItem) => {
      const childItems = parentItem.querySelectorAll('.menu-child-item');
      const childMenu = parentItem.querySelector('.list-menu-child');

      if (!childItems.length || !childMenu) return;

      // Show child menu on parent hover
      parentItem.addEventListener('mouseenter', () => {
        // Remove 'active' from all parents
        document.querySelectorAll('.menu-parent-item.active').forEach(p => p.classList.remove('active'));
        parentItem.classList.add('active');

        // Reset all active child items in other menus
        document.querySelectorAll('.menu-child-item.active').forEach(c => c.classList.remove('active'));

        // Activate first child item and show its grandchild menu
        childItems[0].classList.add('active');
      });

      parentItem.addEventListener('mouseleave', () => {
        parentItem.classList.remove('active');
        childItems.forEach(item => item.classList.remove('active'));
      });

      // Handle grandchild menus
      childItems.forEach((childItem) => {
        childItem.addEventListener('mouseenter', () => {
          // Remove active from siblings
          childItems.forEach(ci => ci.classList.remove('active'));
          childItem.classList.add('active');
        });
      });
    });
  });